import * as React from 'react'

import { Logger, StringMap } from '@utils'
import { AllDownloadsPayload } from '@shared'
import { Subtract } from '../../widgets/DVWebNodeDetail/utils/utils'
import { MetaData, OfflineMetaData } from '../../widgets/DVWebNodeSPA/utils/offlineStorageTypes'

const { Provider, Consumer } = React.createContext({})

export type SaveMetaData = (titleId: string) => Promise<void>
export type GetMetaData = () => Promise<MetaData[]>
export type HasDownloadCompleted = (titleId: string) => boolean
export type PlayOffline = (titleId: string) => void

export type SpaContextProps = {
  saveMetaData: SaveMetaData
  getMetaData: GetMetaData
  strings: StringMap
  downloads: AllDownloadsPayload
  metaData: OfflineMetaData
  playOffline: PlayOffline
  hasDownloadCompleted: HasDownloadCompleted
  logger: Logger
}

export const withSpaContext = <P extends SpaContextProps>(Component: React.ComponentType<P>) => {
  return (props: Subtract<P, SpaContextProps>) => (
    <Consumer>{spaContext => <Component {...(spaContext as SpaContextProps)} {...(props as P)} />}</Consumer>
  )
}

export type MaybeSpaContextProps = {
  saveMetaData?: SaveMetaData
  getMetaData?: GetMetaData
  strings?: StringMap
  downloads?: AllDownloadsPayload
  metaData?: MetaData[]
  playOffline?: PlayOffline
  hasDownloadCompleted?: HasDownloadCompleted
  logger?: Logger
}

export const withMaybeSpaContext = <P extends MaybeSpaContextProps>(Component: React.ComponentType<P>) => {
  return (props: Subtract<P, MaybeSpaContextProps>) => (
    global.__NATIVEAPP__ ? (
      <Consumer>{spaContext => <Component {...(spaContext as MaybeSpaContextProps)} {...(props as P)} />}</Consumer>
    ) : (
      <Component {...(props as P)} />
    )
  )
}

export { Consumer as SpaConsumer, Provider }
